import React, { useEffect } from 'react'
import { connect } from "react-redux";
import Header from './Header'
import Filter from './Filter';
import Search from './Search'
import Category from './Category'
import Footer from './Footer'
import { getData, getMenu, searchItems } from '../redux/actions/restaurant';
import Collapsible from 'react-collapsible';
import Cart from './Cart';
import { getImage, notifyMe, isDigitalMenu } from '../common/Functions';
import { useParams, Redirect } from 'react-router-dom';
import { setTable } from '../redux/actions/table';
import { messaging } from "../init-fcm";
import { setDeviceToken } from '../redux/actions/user';


function Restaurant({ menu, getData, details, getMenu, original_menu, searchItems, searchString, filter, specialCategory,
    error, tableRedux, setTable, setDeviceToken }) {


    let { table } = useParams();
    console.log(table, "tabletable");

    useEffect(() => {
        if (menu.length == 0)
            getMenu();
        if (table)
            setTable(table);
        searchItems();
    }, []);

    useEffect(() => {
        if (!isDigitalMenu) {

            const setNoti = async () => {
                if (messaging) {
                    const token = await messaging.getToken();
                    setDeviceToken(token);
                }
            }

            if (messaging && Notification && Notification.permission === "granted") {
                setNoti();
            }

        }
    }, [])



    if (error) {
        return <Redirect to="/table" />
    }


    return (
        <>
            <header id="top-header" className="fixed border-bottom">
                <Header />
                <Filter searchItems={searchItems} />
            </header>

            {!searchString && specialCategory && specialCategory.cat_id && <Category category={specialCategory} key={specialCategory.cat_id}
                isChildCat={false} image={getImage(specialCategory.cat_id)} />}
            {searchString && menu.length == 0 && <h1>No Items found</h1>}

            {
                menu.map(category => {
                    if (category.child_cat?.length == 1) {
                        let mainCatId = category.cat_id;
                        category = { ...category.child_cat[0] };
                        category.cat_id = mainCatId;
                    }
                    if (category.child_cat) {
                        return (
                            <React.Fragment key={category.cat_id}>
                                <div className="menu-list" id={category.cat_id}  >
                                    <Collapsible open={true} trigger={<h2 className="category-name">
                                        <span className="fa fa-caret-down"></span>
                                        <span>{category.category_name}</span>
                                    </h2>}>
                                        {category.child_cat.map(childCat => <Category category={childCat} key={childCat.cat_id} isChildCat={true} />)}

                                    </Collapsible>
                                </div>
                            </React.Fragment>)
                    } else {
                        return <Category category={category} key={category.cat_id} isChildCat={false} />
                    }

                })
            }

            <Footer menu={menu} />
        </>


    )
}

const mapStateToProps = state => {
    return {
        list: state.restaurant.list,
        details: state.restaurant.details,
        menu: state.restaurant.menu,
        original_menu: state.restaurant.original_menu,
        searchString: state.restaurant.searchString,
        specialCategory: state.restaurant.specialCategory,
        error: state.table.error,
        tableRedux: state.table.table
    };

}



export default connect(mapStateToProps, { getData, getMenu, searchItems, setTable, setDeviceToken })(Restaurant);
